import { TagDomAttribute } from 'tag/ts/tag/model/type/TagDomAttribute';

/**
 * @description Common CSS style strings used in view templates
 * @private
 */
const POSITION_ABSOLUTE_IMPORTANT = 'position: absolute !important; ';
const WIDTH_100_IMPORTANT = 'width: 100% !important; ';
const HEIGHT_100_IMPORTANT = 'height: 100% !important; ';

export const ViewLibrary = {
	/**
	 * @description Root SmartTag container template
	 */
	SMART_TAG_SKELETON:
		// root smart tag container start
		`<div ${TagDomAttribute.SMART_TAG}="$UUID$" ` +
		`style="${POSITION_ABSOLUTE_IMPORTANT}overflow: hidden !important; ` +
		`${WIDTH_100_IMPORTANT}${HEIGHT_100_IMPORTANT}background-color: black !important;">` +
		// skin + player container start
		`<div ${TagDomAttribute.CONTENT}="$UUID$" ` +
		`style="${POSITION_ABSOLUTE_IMPORTANT}${WIDTH_100_IMPORTANT}${HEIGHT_100_IMPORTANT}` +
		'background-color: black !important;" class="player-services-smart-tag-content-element">' +
		'</div>' + // skin + player container end
		// overlay container start
		`<div ${TagDomAttribute.OVERLAY}="$UUID$" ` +
		`style="${POSITION_ABSOLUTE_IMPORTANT}display: block; top: -10000px; z-index: 1000 !important; ` +
		`${WIDTH_100_IMPORTANT}${HEIGHT_100_IMPORTANT}background-color: black !important;">` +
		'</div>' + // overlay container end
		// outer loading animation centering container start
		`<div ${TagDomAttribute.LOADING_ANIMATION}="$UUID$" ` +
		`style="${POSITION_ABSOLUTE_IMPORTANT}${WIDTH_100_IMPORTANT}${HEIGHT_100_IMPORTANT}display: none; ` +
		'justify-content: center !important; align-items: center !important; ' +
		'background-color: rgba( 0, 0, 0, 1 ); z-index: 100 !important;">' +
		'</div>' + // outer loading animation container end
		// diagnostic overlay container start
		`<div ${TagDomAttribute.DIAGNOSTIC}="$UUID$" ` +
		`style="${POSITION_ABSOLUTE_IMPORTANT}display: block; top: 0; left: 0; ` +
		`${WIDTH_100_IMPORTANT}z-index: 9999 !important; pointer-events: none !important;">` +
		'</div>' + // diagnostic overlay container end
		'</div>', // root smart tag container end

	/**
	 * @description Error panel template
	 */
	ERROR_PANEL:
		'<div style="position:absolute; width:100%; height: 100%; opacity: 0; ' +
		'transition-property: opacity; transition-duration: 500ms; transition-timing-function: ease-out; ' +
		'-moz-user-select: none; -ms-user-select: none; -khtml-user-select: none; ' +
		'-webkit-user-select: none; -webkit-touch-callout: none; user-select: none; ' +
		'font-family: var(--font-family-regular), sans-serif !important; color: white !important; ' +
		'text-align: center !important; font-size: 1.8em; ">' +
		// background image
		'<div class="background-image" style="position:absolute; width:100%; height: 100%; ' +
		'background-repeat: no-repeat; background-size: cover; background-position: center; ' +
		'filter: blur(30px); "></div>' +
		// gradient overlay
		'<div class="gradient-background" style="position:absolute; width:100%; height: 100%; ' +
		'background: rgba(0, 0, 0, 0); ' +
		'background: -moz-linear-gradient(top, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.7) 100%); ' +
		'background: -webkit-linear-gradient(top, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.7) 100%); ' +
		'background: -o-linear-gradient(top, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.7) 100%); ' +
		'background: -ms-linear-gradient(top, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.7) 100%); ' +
		'background: linear-gradient(to bottom, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.7) 100%); ' +
		'filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#4c4c4c\', endColorstr=\'#131313\', GradientType=0); ' +
		'"></div>' +
		// copy wrapper
		'<div style="position:absolute; width:100%; height: 100%; display: flex; ' +
		'justify-content:center; align-items:center; ">' +
		// copy container
		'<div style="position: relative; width: 80%;" class="smart-tag-error-panel-content">$MESSAGE$</div>' +
		'</div>' +
		'</div>'
};